import { ReactNode } from 'react'

import { CurrencyCode, Field, PageFilters, Pagination } from 'types'

export interface BulkActionsRenderProps<RecordType> {
    recordName: string
    reloadData: () => void
    selectedRows: RecordType[]
    unselectAllRows: () => void
    pagination: Pagination
    updatePastPage?: {
        isAllRowsSelected: boolean
        selected: boolean
        onChange: (selected: boolean) => void
        filters: PageFilters
        metrics?: Field<RecordType>[]
        currencyCode?: CurrencyCode
    }
    setPastPageSelectionDisable?: (isDisabled: boolean) => void
    onCancel: () => void
    disabled?: boolean
    extraFilterParams?: { [key: string]: string | number | undefined }
}

// When using this:
// - title would be the text of a button in the bulk actions bar.
// - when clicked, render would invoked to show the form that replaces the actions bar.
interface TwoStepBulkActionsProps<RecordType> {
    render: (props: BulkActionsRenderProps<RecordType>) => ReactNode
    title: string
    showDryRunPrompt?: boolean
    disabled?: boolean
    disabledReason?: string
}

// When using this:
// - render would invoked to be shown as part of the actions bar directly.
interface SingleStepBulkActionsProps<RecordType> {
    render: (props: BulkActionsRenderProps<RecordType>) => ReactNode
    disabled?: boolean
    disabledReason?: string
}

export const isBulkActionTwoStep = (
    object: any
): object is TwoStepBulkActionsProps<any> => {
    return (
        !!object &&
        typeof object === 'object' &&
        'title' in object &&
        'render' in object
    )
}

export interface Props<RecordType> {
    title?: ReactNode
    recordName: BulkActionsRenderProps<RecordType>['recordName']
    reloadData: BulkActionsRenderProps<RecordType>['reloadData']
    selectedRows: BulkActionsRenderProps<RecordType>['selectedRows']
    isAllRowsSelected: boolean
    unselectAllRows: BulkActionsRenderProps<RecordType>['unselectAllRows']
    bulkActions: (
        | TwoStepBulkActionsProps<RecordType>
        | SingleStepBulkActionsProps<RecordType>
    )[]
    showBulkActions?: boolean
    pagination: BulkActionsRenderProps<RecordType>['pagination']
    updatePastPage?: BulkActionsRenderProps<RecordType>['updatePastPage']
}
